import firebase from "firebase/compat/app";
import "firebase/compat/auth";

import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const config = {
  apiKey: "AIzaSyA4utM9Apaf-cdyYj30wRKZHcPKXeC1EnE",
  authDomain: "tctimeworkadmin.firebaseapp.com",
  projectId: "tctimeworkadmin",
  storageBucket: "tctimeworkadmin.appspot.com",
  messagingSenderId: "668952171937",
  appId: "1:668952171937:web:5262ca671d3e8820d5a7e0",
  measurementId: "G-QLQQ54P9HX",
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export const db = getFirestore(firebase.initializeApp(config));

export default firebase;
